import { Button, KIND } from 'baseui/button'
import { ChevronDown, ChevronRight, Show } from 'baseui/icon'
import IconCarbonDownload from '../IconCarbonDownload/IconCarbonDownload'
import { SIZE } from 'baseui/input'
import RowsNestedRequestDetailsTable from '../RowsNestedRequestDetailsTable/RowsNestedRequestDetailsTable'
import useRowsRequestTable from './useRowsRequestTable'

const RowsRequestTable = ({
  isSentRequest,
  striped,
  workflowName,
  description,
  requestDate,
  requestData,
  requestUrl,
  index,
  id,
}) => {
  const { css, t, CenteredBodyCell, expanded, toggleExpand, downloadFileName, directionText, formatDate, downloadJSON } = useRowsRequestTable({ id, isSentRequest })

  return (
    <div role='row' className={css({ display: 'contents' })}>
      <CenteredBodyCell $striped={striped}>
        <Button
          size={SIZE.mini}
          kind={striped ? KIND.tertiary : KIND.secondary}
          onClick={() => toggleExpand(index)}
          shape='square'
        >
          {expanded === index ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
        </Button>
        <span className={css({ marginLeft: '10px' })}>{directionText()}</span>
      </CenteredBodyCell>

      <CenteredBodyCell $striped={striped}>{workflowName}</CenteredBodyCell>

      <CenteredBodyCell $striped={striped}>{description}</CenteredBodyCell>

      <CenteredBodyCell $striped={striped}>{formatDate(requestDate)}</CenteredBodyCell>

      <CenteredBodyCell $striped={striped}>
        <Button
          kind={KIND.primary}
          size={SIZE.mini}
          onClick={() => toggleExpand(index)}
          endEnhancer={() => <Show size={16} />}
          overrides={{
            BaseButton: {
              style: () => ({
                marginRight: '5px',
              }),
            },
          }}
          className={css({ marginRight: '5px' })}
        >
          {t('subscriptionForm:subscription_actions_module.export_logs.modal_view_button')}
        </Button>
        <Button
          kind={striped ? KIND.tertiary : KIND.secondary}
          size={SIZE.mini}
          onClick={() => downloadJSON(requestData, downloadFileName)}
          endEnhancer={() => <IconCarbonDownload size={16} />}
        >
          {t('subscriptionForm:subscription_actions_module.export_logs.modal_download_button')}
        </Button>
      </CenteredBodyCell>
      {expanded === index && (
        <RowsNestedRequestDetailsTable
          isSentRequest={isSentRequest}
          requestResponse={requestData}
          requestUrl={requestUrl}
        />
      )}
    </div>
  )
}

export default RowsRequestTable
